/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Module) {
	'use strict';
	/*globals Tc */

	/**
	 * Subscribes to channels: [EcommerceProductDataHub]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData]
	 * Triggers channel events: [subscribeForProductData]
	 *
	 * @namespace Tc.Module
	 * @class ProductTeaser
	 * @extends Tc.Module
	 */

	Module.ProductTeaser = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			mod.$formPart = $('<div/>', {'class': 'productTeaserInvisibleFormPart'});
			mod.isMobile = $('body').hasClass('is-mobile');
			mod.priceOrder = $('.modPriceOrderContainer', mod.$ctx);
			mod.useInForm = (mod.$ctx.hasClass('form-teaser') && mod.$ctx.is('form *')) || false;
			mod.translationDuration = mod.$ctx.data('translation-duration');
			mod.translationMonths = mod.$ctx.data('months-translation');

			if ($('.modPromoBadge .ribbon', mod.$ctx).text()) {
				mod.$ctx.addClass('with-badge');
			}
			if ($('.promo-image img', mod.$ctx).length > 0) {
				mod.$ctx.addClass('with-promo-image');
			}
			if (!$('body').hasClass('cq_isEditMode') && !mod.useInForm) {
				mod.bindClickEvent();
			}

			if(mod.useInForm) {
				mod.bindFormClickEvent();
			}

			if(!mod.isMobile && !mod.useInForm) {
				mod.$ctx.find('.modProductImage img, .modTitle h3').wrap('<a class="product-link">');
			}

			mod.onStartProductDataSubscription();
			callback();
		},

		after: function() {
			var mod = this;
			if (mod.$ctx.closest('.modProductOfferPreviews').length > 0) {
				mod.adjustForStage();
			}
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function() {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function(channel, fetchDataOnSubscribe) {
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);

					// If component was lazy loaded, request initialization data
					// from data hub.
					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({info: data});
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function(data) {
			var mod = this;
			if(data.info.family.getDetailPagePath() && !mod.useInForm) {
				mod.$ctx.find('.product-link').attr('href', data.info.family.getDetailPagePath());
			}

			if (mod.productDataChannel) {
				mod.setTitle(data.info.family.getSeoName());
			} else {
				mod.setTitle();
			}
			if(mod.useInForm) {
				mod.gotDataFromHub(data);
				mod.fire('PriceAdded', {}, ['formpriceupdate']);
			}
		},


		bindClickEvent: function() {
			var mod = this;
			if(mod.isMobile) {
				// bind detail link click to whole teaser only if the price order detail link is in a specific style
				if (mod.priceOrder.find('.details-link.scs-primary-link').length > 0 && mod.$ctx.closest('.carouselContainer').length === 0) {
					mod.$ctx.css('cursor', 'pointer');
					mod.$ctx.addClass('linked-teaser');
					mod.$ctx.on('click', function(){
						mod.priceOrder.trigger('detailsClick');
					});
				}
			} else {
				if (mod.$ctx.closest('.carouselContainer').length === 0 && !mod.$ctx.hasClass('type-product') && !mod.$ctx.hasClass('type-product-wide')) {
					mod.$ctx.css('cursor', 'pointer');
					mod.$ctx.on('click', function (event) {
						if (!$(event.target).is('select')
							&& !$(event.target).is('.secondary-button')
							&& !$(event.target).is('.primary-button')
							&& !$(event.target).is('[data-name] a')
							&& !$(event.target).is('.scs-primary-link')
							&& !$(event.target).is('.ignore-click-forward')) {
							mod.priceOrder.trigger('ctaClick');
						}
					});
				}
			}
		},

		bindFormClickEvent: function () {
			var mod = this;
			mod.$ctx.on('click', function(event) {
				var $grid = mod.$ctx.closest('.modGridLayout');
				var mobileOrDesktopClasses = mod.isMobile ? '.modMobileGallery' : '.modGridLayout .column >';

				mod.$ctx.closest('.modBackgroundContainer').addClass('selected');
				$grid.find('.productTeaserInvisibleFormPart').remove();
				mod.$ctx.append(mod.$formPart);
				mod.fire('PriceAdded', {}, ['formpriceupdate']);
			});
		},

		gotDataFromHub: function(info) {
			info = info.info;
			var mod = this;
			var productInfo = {};
			mod.$formPart.empty();
			if(info && info.product) {
				productInfo = {
					'Name': info.product.getSubscriptions().getName(info.subscriptionId),
					'Duration': info.subscriptionDuration,
					'Id':  info.subscriptionId,
					'SAPId' : info.product.getId(),
					'Title': info.product.getName(),
					'Color' : info.color,
					'MemorySize' : info.memory,
					'Price' : info.product.getPrice(info.subscriptionId, info.subscriptionDuration).value()
				};
				$.each(productInfo, function( k, v ) {
					$('<input>').attr({
						type: 'hidden',
						'class' : 'mobileInfo mobileSubscription' + k,
						name: 'mobileSubscription' + k,
						value: v
					}).appendTo(mod.$formPart);
				});
				mod.$formPart.children('.mobileSubscriptionPrice')
					.attr('data-label', info.product.getName() + ', ' + mod.translationDuration + ' ' + info.subscriptionDuration + ' ' + mod.translationMonths)
					.attr('data-onetime-charge', info.product.getPrice(info.subscriptionId, info.subscriptionDuration).value())
					.attr('data-hascost', '1')
					.attr('data-type', 'base');
			}
		},

		setTitle: function(title) {
			var mod = this;
			if (!mod.title) {
				mod.title = $('.modTitle h2, .modTitle h3, .title h2, .title h3', mod.$ctx);
			}
			mod.title.each(function(){
				var elem = $(this);
				if (!elem.data('text')) {
					elem.data('text', elem.text());
				}
				if (title) {
					elem.text(title);
				} else {
					elem.text(elem.data('text'));
				}
			});
		},

		adjustForStage: function() {
			var mod = this, i, detachedPreviewImage,
				priceContainer = $('.modPriceOrderContainer', mod.$ctx).first(),
				slideContainer = mod.$ctx.closest('.product-offer-preview-slide');
			if (!$('body').hasClass('cq_isEditMode')) {
				if (priceContainer.length > 0) {
					$('.productmodelfilter', mod.$ctx).detach().insertBefore(priceContainer);
				}
				if (slideContainer.length > 0) {
					detachedPreviewImage = $('<div class="modProductTeaser productimage-container">').append($('.productimage', mod.$ctx).detach());
					slideContainer.prepend(detachedPreviewImage);
				}
			}
		}
	});
})(window.Tc.$, window.Tc.Module);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/ecommerce/clientlibs/shared/js/modules/Tc.Module.ProductTeaser.js
// module id = 255
// module chunks = 0